import React from "react";
import { formatCurrency } from "./format";
import { renderVehicles } from "./views/vehicles";
import { renderServices } from "./views/services";
import { renderInvoices } from "./views/invoices";
import { renderDeliveryNotes } from "./views/deliveryNotes";
import { renderSavings } from "./views/savings";

const ResultView = ({ questionId, data, translate, currency }) => {
  const money = (value) => formatCurrency(value, currency);
  const ctx = { translate, money };

  return (
    renderVehicles(questionId, data, ctx) ||
    renderServices(questionId, data, ctx) ||
    renderInvoices(questionId, data, ctx) ||
    renderDeliveryNotes(questionId, data, ctx) ||
    renderSavings(questionId, data, ctx) ||
    null
  );
};

export default ResultView;
